const Blur = ({onClick}) => {
    return(<div className="overlay" onClick={onClick}/>);
}

export default Blur;